import React, { Component } from 'react';
import config from '../../config';
import queryString from 'query-string';


const appBuddyEmail = process.env.REACT_APP_ZOOM_EMAIL;

class ZoomComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { user: props.user };
  }

  getSignatureForCurrentMeeting = async (meetingNumber, role) => {
    const response = await fetch(
      '/api/zoom-signature?meetingNumber=' + meetingNumber + '&role=' + role
    );
    const body = await response.json();

    console.log(body);
    if (response.status !== 200) throw Error(body.message);

    return body.signature;
  };

  componentDidMount() {
    const { user, ...rest } = this.props;

    if (!user.id) {
      return;
    }
    var getQuerystring = window.location.href.split('/');
    var meetingNumber = getQuerystring[4];
    var meetingType = getQuerystring[5]; // start/join
    var userId = appBuddyEmail;
    var role = '1';
    var userName = 'AppBuddy';

    if (meetingType == 'join') {
      userId = user.attributes.email;
      userName = user.attributes.profile.firstName + ' ' + user.attributes.profile.lastName;
    }

    // backdoor to test lengh meeting, nr of participants
    if (!(typeof window === 'undefined')) {
      let queries = queryString.parse(window.location.search);
      if (queries.userId && queries.userName) {
        userId = queries.userId;
        userName = queries.userName;
        role = queries.role;
      }
    }

    import('@zoomus/websdk').then(component => {
      console.log(component);

      // TODO investigate why can't be referenced from local
      //component.ZoomMtg.setZoomJSLib('node_modules/@zoomus/websdk/dist/lib', '/av');

      component.ZoomMtg.setZoomJSLib('https://source.zoom.us/1.9.1/lib', '/av');
      component.ZoomMtg.preLoadWasm();
      component.ZoomMtg.prepareJssdk();

      this.getSignatureForCurrentMeeting(meetingNumber, role) // 1 for host; 0 for attendee
        .then(res => {
          console.log(res);

          var host = 'http://localhost:3000/';
          const isServer = typeof window === 'undefined';
          if (!isServer) {
            host = window.location.protocol + '//' + window.location.host;
          }

          component.ZoomMtg.init({
            leaveUrl: host,
            success: function() {
              console.log('signature', res);
              component.ZoomMtg.join({
                meetingNumber: meetingNumber,
                userName: userName,
                signature: res,
                apiKey: config.zoomApiKey,
                userEmail: userId,
                passWord: 'Hey123',
                success: function(res) {
                  console.log('join meeting success');
                  console.log('get attendeelist');
                },
                error: function(res) {
                  console.log(res);
                },
              });
            },
            error: function(res) {
              console.log(res);
            },
          });
        })
        .catch(err => console.log(err));
      //});
    });
  }

  render() {
    const { user, ...rest } = this.props;
    return <div></div>;
  }
}

export default ZoomComponent;
